/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import PropTypes from 'prop-types';
import React from 'react';
import { Input, InputIcon } from '@salesforce/design-system-react';

import mcLib from '../../../api/mc-lib';

class SuccessCommunitySearch extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      search: '',
    };
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.navigateToSearch();
    }
  };

  setSearch = (event) => {
    this.setState({ search: event.target.value });
  };

  navigateToSearch = () => {
    const encodedSearch = encodeURIComponent(this.state.search);
    mcLib.logEvent('search success community', encodedSearch);
    window.open(`https://success.salesforce.com/search?keywords=${encodedSearch}`, '_blank'); // eslint-disable-line no-undef
  };

  render() {
    return (
      <div className="slds-m-top--large">
        <Input
          assistiveText={this.props.assistiveText}
          iconLeft={
            <InputIcon
              assistiveText={{
                icon: 'Search',
              }}
              name="search"
              category="utility"
              onClick={(event) => {
                this.setSearch(event);
                this.navigateToSearch();
              }}
            />
          }
          placeholder={this.props.placeholder}
          onChange={this.setSearch}
          onKeyDown={this.handleKeyDown}
        />
        <hr className="slds-m-top--medium slds-m-bottom--none" />
      </div>
    );
  }
}

SuccessCommunitySearch.displayName = 'Success Community Search';

SuccessCommunitySearch.propTypes = {
  assistiveText: PropTypes.object,
  placeholder: PropTypes.string,
};

SuccessCommunitySearch.defaultProps = {
  assistiveText: 'Search Success Community',
  placeholder: 'Search Success Community',
};

export default SuccessCommunitySearch;
